import React from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';

interface ErrorAlertProps {
  title: string;
  description?: string;
  descriptionWhiteSpace?: 'normal' | 'pre-line';
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  title,
  description,
  descriptionWhiteSpace,
}) => {
  const isMultiLine = descriptionWhiteSpace === 'pre-line';

  return (
    <Alert
      status="error"
      borderRadius="12px"
      flexDirection={isMultiLine ? 'column' : undefined}
      alignItems={isMultiLine ? 'flex-start' : undefined}
    >
      <AlertIcon />
      <AlertTitle>{title}</AlertTitle>
      {description && (
        <AlertDescription whiteSpace={descriptionWhiteSpace}>
          {description}
        </AlertDescription>
      )}
    </Alert>
  );
};
